import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, TemplateRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import {
  DataTableActionEnum,
  DataTableColumnFilters,
  DataTableColumnFiltersApi,
  DataTableColumnModel,
  DataTableEventsEnum,
  DataTableInlineEditingConfigEnum,
  DataTableItemsPerPageEnum,
  DataTableSortEnum,
  DataTableStateModel
} from './dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';
import { DynamicTableFilterComponent } from '../dynamic-table-filter/dynamic-table-filter.component';
import { DatatableFilterNameDisplayPipe } from 'app/shared/pipes/datatable-filter-name-display.pipe';
import { DynamicTableColumnSettingsComponent } from '../dynamic-table-column-settings/dynamic-table-column-settings.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FiltersModalComponent } from '../filters-modal/filters-modal.component';
import { CheckboxFormFieldComponent } from "../forms/fields/checkbox-form-field/checkbox-form-field.component";
import { InputFormFieldComponent } from '../forms/fields/input-form-field/input-form-field.component';
import { BehaviorSubject, take } from 'rxjs';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ICredentials } from 'app/shared/models/credentials.model';
import { AuthService } from 'app/shared/services/auth.service';
import { USER_ROLES } from 'app/shared/enums/user-roles.enum';
import { ListResponse } from 'app/shared/models/list-response.model';
import { ToastTypesEnum } from 'app/shared/enums/toast.enum';
import { ToastrService } from 'ngx-toastr';
import { DynamicTableService } from './dynamic-table.service';
@Component({
  selector: 'app-dynamic-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgxDatatableModule,
    TranslateModule,
    DynamicTableFilterComponent,
    DatatableFilterNameDisplayPipe,
    DynamicTableColumnSettingsComponent,
    CheckboxFormFieldComponent,
    InputFormFieldComponent,
  ],
  templateUrl: './dynamic-table.component.html',
  styleUrl: './dynamic-table.component.scss'
})
export class DynamicTableComponent implements OnInit, OnDestroy {
  @ViewChild('table') table: any;
  @ViewChild('filtersTable') filtersTable: any;

  @ViewChild('saveFiltersContent') saveFiltersContent!: TemplateRef<any>;
  @ViewChild('applyFiltersContent') applyFiltersContent!: TemplateRef<any>;
  @Input() rows: any = [];
  @Input() columnMode: ColumnMode = ColumnMode.force;
  @Input() columns: any = [];
  @Input() headerHeight: number = 50;
  @Input() footerHeight: number = 50;
  @Input() rowHeight: number | 'auto' = 'auto';
  @Input() tableSizeClass!: string;
  @Input() useExternalApi: boolean = false;
  @Input() noLimit: boolean = false;
  @Input() dataTableMinWidth: number = 1200;
  @Input() stickyHeader: boolean = true;
  @Input() showSaveBtn: boolean = false;
  @Input() showColumnsSettingsBtn: boolean = false;
  @Input() showExportDataBtn: boolean = false;
  @Input() exportDataApiPath!: string;
  @Input() exportQueryGlobalSearch!: string;
  @Input() globalSearchTerm!: string;
  @Input() totalCount: number = 0;
  @Input() showGoToBtn: boolean = false;
  @Input() hidePagination: boolean = false;
  @Input() datatableDisplayAllNames: DataTableColumnFilters[] = [];
  @Input() filters: DataTableColumnFiltersApi[] = [];
  @Input() defaultColumns = [];
  @Input() selectedFilterName = '';
  @Input() showSaveDatatableFilterBtn: boolean = false;
  @Input() gridSettingsChanged: boolean = false;

  @Input() itemsPerPage = [
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_20, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_20.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_50, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_50.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100.toString() },
  ]
  @Input() dataTableState: DataTableStateModel = {
    sortingValue: {
      prop: '',
      dir: ''
    },
    pageNumber: 1,
    showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10,
    gridName: '',
    tableType: ''
  };
  @Output() dataTableStateEvent = new EventEmitter<DataTableStateModel>();
  @Output() saveDataTableEvent = new EventEmitter<Object>();
  @Output() linkedValueClickEvent = new EventEmitter<Object>();
  @Output() currentEditedRowEvent = new EventEmitter<Object>();
  @Output() saveRowEvent = new EventEmitter<Object>();
  @Output() actionButtonEvent = new EventEmitter<Object>();
  @Output() changeInputFieldEvent = new EventEmitter<Object>();
  @Output() enableEditEvent = new EventEmitter<Object>();
  @Output() saveDataTableSettingsEvent = new EventEmitter<DataTableStateModel>();
  @Output() onSelectSearchEvent = new EventEmitter<void>();
  @Output() onClearEvent = new EventEmitter<void>();
  @Output() updateDataTableSettingsEvent = new EventEmitter<DataTableStateModel>();


  dataTableEventsChangePage = DataTableEventsEnum.CHANGE_PAGE;
  dataTableEventsChangeItemPerPage = DataTableEventsEnum.CHANGE_ITEMS_PER_PAGE;
  editedFields: any = {};
  editedRows: any = [];
  inputField = DataTableInlineEditingConfigEnum.INPUT_FIELD;
  selectField = DataTableInlineEditingConfigEnum.SELECT_FIELD;
  isSaveDisabled: boolean = true;
  orgRows: any = [];
  dataTableActionEnum = DataTableActionEnum;
  showDatatableFilter: boolean = false;
  datatableFilterPosition: any = {};
  filterValues: DataTableColumnFilters[] = [];
  columnProp!: string;
  displayName!: string;
  currentFilter: DataTableColumnFiltersApi = {};
  showFilterSearch: boolean = false;
  showDatatableColumnSettings: boolean = false;
  orgColumns: any = [];
  savedFilterName: string = '';
  saveAsGlobal: boolean = false;
  savedFilters: any[] = [];
  selectedFilter: any = null;
  tempFilters: DataTableColumnFiltersApi[] = [];
  isSaveDisabled$ = new BehaviorSubject<boolean>(true);
  searchInput$ = new Subject<string>();
  externalSearch: boolean = true;
  enableAddSelectBtn: boolean = true;
  isTableVisible: boolean = true;
  credentials!: ICredentials | undefined;
  isAdmin: boolean = false;
  isEditMode = false;
  savedFiltersTotalCount: number = 0;
  savedFiltersItemsPerPage = [
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_20, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_20.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_50, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_50.toString() },
    { id: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100, name: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100.toString() },
  ]
  savedFiltersDataTableState: DataTableStateModel = {
    sortingValue: {
      prop: '',
      dir: ''
    },
    pageNumber: 1,
    showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100,
    gridName: '',
    tableType: ''
  };
  defaultConfigurationTranslation = this.translate.instant('label.empty_configuration');

  private unsubscribe$ = new Subject<void>()

  constructor(
    public helperService: HelperService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private configurationService: ConfigurationService,
    private authService: AuthService,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private dynamicTableService: DynamicTableService
  ) {
    this.searchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((data: any) => {
        this.onSelectSearchEvent.emit(data);
        this.enableAddSelectBtn = true;
      });
  }

  ngOnInit(): void {
    this.handleDatatableColumns();
    this.orgRows = this.helperService.deepCopy(this.rows);
    this.credentials = this.authService.getCredentials();
    this.isAdmin = this.credentials?.role === USER_ROLES.ADMIN_USER;
  }

  handleDatatableColumns() {
    this.columns.forEach((column: any) => {
      column.showColumn === undefined ? column.showColumn = true : column.showColumn;
      column.isColumnFilterActive === undefined ? column.isColumnFilterActive = false : column.isColumnFilterActive;

      if (column.fieldType === 'boolean') {
        column.dataTableColumnFilters = this.configurationService.getBooleanDataTableColumnFilters();
      }

    });

    this.orgColumns = this.helperService.deepCopy(this.columns);

    this.columns = this.columns.filter((column: any) => column.showColumn);
  }

  onSort(data: any) {
    if (!this.useExternalApi) {
      return;
    }

    const sorts = data?.sorts?.[0];
    const currentSorting = this.dataTableState.sortingValue;

    if (sorts) {
      if (currentSorting.prop !== sorts.prop) {
        this.dataTableState.sortingValue = { prop: sorts.prop, dir: DataTableSortEnum.SORT_ASC };
      } else if (currentSorting.dir === DataTableSortEnum.SORT_ASC) {
        this.dataTableState.sortingValue.dir = DataTableSortEnum.SORT_DESC;
      } else {
        const orgSortingValue = {
          prop: '',
          dir: DataTableSortEnum.SORT_DESC
        };
        this.dataTableState.sortingValue = this.helperService.deepCopy(orgSortingValue);
      }
    }

    this.dataTableState.pageNumber = 1;
    this.dataTableState.datatableColumns = this.columns;
    this.setDatatableStateOnSessionAndEmitChangeEvent(true);
  }

  onResize($event: any) {
    if ($event && $event.column) {
      this.columns = this.columns.map((col: DataTableColumnModel) =>
        col.prop === $event.column.prop ? { ...col, width: $event.newValue } : col
      );

      const columns = this.replaceByProp(this.orgColumns, this.columns);
      this.dataTableState.datatableColumns = columns;
      this.setDatatableStateOnSessionAndEmitChangeEvent(false);
    }
  }

  replaceByProp(orgColumns: DataTableColumnModel[], columns: DataTableColumnModel[]): DataTableColumnModel[] {
    const byProp = new Map(columns.map(x => [x.prop, x]));
    return orgColumns.map(item => byProp.get(item.prop) ?? item);
  }

  changeEvent(data: any, type: string) {

    if (!this.useExternalApi) {
      this.table.offset = 0;
      return;
    }

    switch (type) {
      case this.dataTableEventsChangePage:
        this.dataTableState.pageNumber = data.page;
        break;
      case this.dataTableEventsChangeItemPerPage:
        this.dataTableState.pageNumber = 1;
        this.dataTableState.showItemsPerPage = data.id;
        break;
    }

    this.dataTableState.datatableColumns = this.columns;
    this.setDatatableStateOnSessionAndEmitChangeEvent(true);
  }

  updateValue(
    event: any,
    columnProperty: string,
    rowIndex: number,
    row: any,
    inputOnBlur: boolean,
    bindValue?: string,
    selectFieldKey?: string,
    items?: Object[],
    isRelatedField?: boolean,
    addSelectedItem?: boolean,
  ) {
    const columnIdentifier = rowIndex + '-' + columnProperty;
    row.rowIdentifier = columnIdentifier;
    this.editedFields[columnIdentifier] = false;
    if (bindValue) {
      this.rows[rowIndex][columnProperty] = event ? event[bindValue || 'name'] : null;

      if (addSelectedItem) {
        const selectedItem = `${columnProperty}_selectedItem`;
        if (!row[selectedItem]) {
          row[selectedItem] = {};
        }

        this.rows[rowIndex][selectedItem] = event;
      }

      const relatedItems = `${columnProperty}_items`;
      const addedRelatedItems = `${columnProperty}_added_items`;

      if (!row[relatedItems]) {
        row[relatedItems] = [];
      }

      if (!row[addedRelatedItems]) {
        row[addedRelatedItems] = [];
      }

      const existItem = items?.some(item => item === event);

      if (event && items && !existItem) {
        if (isRelatedField) {
          row[relatedItems].push(event);
          row[addedRelatedItems].push(event);
        } else {
          items.push(event);
        }
      }

    } else {
      this.rows[rowIndex][columnProperty] = event.target.value;
    }
    this.rows = [...this.rows];

    this.editedRows[row.rowIdentifier] = row;
    this.isSaveDisabled = !(!!Object.keys(this.editedRows));

    if (inputOnBlur) {
      return;
    }

    this.currentEditedRowEvent.emit({ columnProperty, row, rowIndex, selectFieldKey });
  }

  selectOnBlur(columnProperty: string, rowIndex: number, row: any) {
    const columnIdentifier = rowIndex + '-' + columnProperty;
    row.rowIdentifier = columnIdentifier;
    this.editedFields[columnIdentifier] = false;
  }

  enableEdit(
    rowIndex: number,
    columnProperty: string,
    row: any,
    selectFieldKey?: string,
  ) {
    this.editedFields[rowIndex + '-' + columnProperty] = true;
    row.selectedValue = row[columnProperty];
    this.enableEditEvent.emit({ row, columnProperty, selectFieldKey });
  }

  discardChanges() {
    // TODO: ADD CONFIRM MODAL
    const data = this.helperService.deepCopy(this.orgRows)
    this.rows = [...data];
    this.editedRows = [];
    this.isSaveDisabled = true;
  }

  changeTableInput(event: any, columnProperty: string, rowIndex: number, row: any) {
    this.changeInputFieldEvent.emit({ event, columnProperty, rowIndex, row });
  }

  actionButton(row: any, rowIndex: number, action: string) {

    if (action === this.dataTableActionEnum.SAVE && !row.saveEnabled) {
      return;
    }
    this.actionButtonEvent.emit({ row, rowIndex, action });
  }

  saveDataTable() {
    const editedRowsWithoutDuplicates = [...new Map(Object.values(this.editedRows).map((row: any) =>
      [row['rowIdentifier'], row])).values()];


    this.saveDataTableEvent.emit(editedRowsWithoutDuplicates);
  }

  onLinkedValueClick(row: any, column: string) {
    this.linkedValueClickEvent.emit({ row, column });
  }

  openDatatableFilter(id: string, name: string, showFilterSearch: boolean, dataTableColumnFilters: DataTableColumnFilters[]) {
    setTimeout(() => {
      this.showDatatableFilter = !this.showDatatableFilter;
      this.setDatatableFilterPosition(id, name, showFilterSearch, dataTableColumnFilters);
    });
  }

  setDatatableFilterPosition(id: string, name: string, showFilterSearch: boolean, filterValues: DataTableColumnFilters[]) {
    const columnId = document.getElementById(id);
    if (columnId) {
      const calculatePosition = columnId.getBoundingClientRect();

      let left = calculatePosition.left + window.scrollX;
      const popupWidth = 20 * 16;  // dynamic-table-filter.component.scss (.datatable-filter-popup class => 20rem)
      const viewportWidth = window.innerWidth;

      if (left + popupWidth > viewportWidth) {
        left = viewportWidth - popupWidth - 20;
      }

      this.datatableFilterPosition = {
        top: `${calculatePosition.bottom + window.scrollY + 10}px`,
        left: `${left}px`,
      };

      this.columnProp = id;
      this.displayName = name;
      this.filterValues = filterValues;
      this.showFilterSearch = showFilterSearch;
      this.currentFilter = this.filters.find((obj: DataTableColumnFiltersApi) => obj.columnName === id) as DataTableColumnFiltersApi;
    }
  }

  closeFilter() {
    this.showDatatableFilter = false;
    this.columnProp = '';
    this.filterValues = [];
  }

  applyFilter(data: DataTableColumnFiltersApi) {
    const existingFilter = this.filters.find((obj: DataTableColumnFiltersApi) => obj.columnName === data.columnName);

    if (existingFilter) {
      existingFilter.columnName = data.columnName;
      existingFilter.displayName = data.displayName;
      existingFilter.columnSearchValue = data.columnSearchValue;
      existingFilter.columnSelectedValues = data.columnSelectedValues;
      if (data.columnDateTimeRangeValues) {
        existingFilter.columnDateTimeRangeValues = {
          from: data.columnDateTimeRangeValues.from || null,
          to: data.columnDateTimeRangeValues.to || null
        };
      }
    } else {
      this.filters.push(data);
    }

    this.filters = this.removeEmptyFilters();
    this.dataTableState.datatableFilters = this.filters;

    this.showHideSaveDatatableFilterBtn(true);
    this.dataTableState.pageNumber = 1;
    this.setDatatableStateOnSessionAndEmitChangeEvent(true);
    this.closeFilter();
  }

  showHideSaveDatatableFilterBtn(show: boolean) {
    this.showSaveDatatableFilterBtn = show;
  }

  filterHasValue(data: any) {
    const column = this.columns.find((obj: DataTableColumnModel) => obj.prop === data.columnName);
    if (column) {
      column.isColumnFilterActive = data.isColumnFilterActive;
    }

    const orgColumn = this.orgColumns.find((obj: DataTableColumnModel) => obj.prop === data.columnName);
    if (orgColumn) {
      orgColumn.isColumnFilterActive = data.isColumnFilterActive;
    }

    this.dataTableState.datatableColumns = this.orgColumns;
  }

  clearFilter(item: DataTableColumnFiltersApi, columnFilter?: string) {
    if (columnFilter || columnFilter === '') {
      item.columnSelectedValues = item.columnSelectedValues ? item?.columnSelectedValues.filter((item: string) => item !== columnFilter) : null;
    } else {
      item.columnSearchValue = null;
      if (item.columnDateTimeRangeValues) {
        item.columnDateTimeRangeValues = { from: null, to: null };
      }
    }

    const resetActiveFilter = {
      columnName: item.columnName,
      isColumnFilterActive: item && (item.columnSearchValue || (item.columnSelectedValues && item.columnSelectedValues.length > 0) ||
        (item.columnDateTimeRangeValues && (item.columnDateTimeRangeValues.from || item.columnDateTimeRangeValues.to)))
    };
    this.filterHasValue(resetActiveFilter);

    this.filters = this.removeEmptyFilters();
    this.dataTableState.datatableFilters = this.filters;
    this.showHideSaveDatatableFilterBtn(true);
    this.dataTableState.pageNumber = 1;
    this.setDatatableStateOnSessionAndEmitChangeEvent(true);
  }

  removeEmptyFilters() {
    const filters = this.filters.filter(filter =>
      !!filter.columnSearchValue ||
      (filter.columnSelectedValues && filter.columnSelectedValues.length > 0) ||
      (filter.columnDateTimeRangeValues && (filter.columnDateTimeRangeValues.from || filter.columnDateTimeRangeValues.to))
    );
    return filters;
  }

  openDatatableColumnSettings() {
    this.showDatatableColumnSettings = true;
    this.renderer.addClass(document.body, 'no-scroll');
  }

  closeColumnsSettings() {
    this.showDatatableColumnSettings = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  applyColumnsSettings(data: any, isApplyDatatableFilter?: boolean) {

    let newArray = data;

    if (isApplyDatatableFilter) {

      newArray = data.map((dataColumn: any) => {
        const orgColumn = this.orgColumns.find((orgColumn: any) => orgColumn.prop === dataColumn.prop);

        if (orgColumn) {
          return { ...dataColumn, dataTableColumnFilters: orgColumn.dataTableColumnFilters };
        }

        return dataColumn;
      });

      this.orgColumns = newArray;

    } else {
      this.orgColumns = [...newArray];
    }


    this.columns = newArray.filter((column: any) => column.showColumn);
    this.showDatatableColumnSettings = false;
    this.renderer.removeClass(document.body, 'no-scroll');
    this.dataTableState.datatableColumns = newArray;

    if (this.columns.length === 0) {
      this.hardResetTable();
    }

    if (!isApplyDatatableFilter) {
      this.showHideSaveDatatableFilterBtn(true);
    }

    this.setDatatableStateOnSessionAndEmitChangeEvent(false);
  }

  onSaveDatatableFilterBtn() {
    this.dataTableState.datatableFilterName = this.savedFilterName;
    this.selectedFilterName = this.savedFilterName;
    this.dataTableState.datatableFilterIsGlobal = this.saveAsGlobal;
    this.filters = [...this.tempFilters];

    this.saveDataTableSettingsEvent.emit(this.dataTableState);

    this.savedFilterName = '';
    this.saveAsGlobal = false;
  }

  openApplyDatatableFilters() {
    this.openFiltersModal(this.applyFiltersContent, 'buttons.apply_saved_filters', 'buttons.apply', 'buttons.cancel');
    this.getDataTableFilterList();
  }

  onSaveDatatableFilterBtnModal() {
    this.tempFilters = [...this.filters];
    this.updateSaveButtonState();
    this.openFiltersModal(this.saveFiltersContent, 'buttons.save_filters', 'buttons.save', 'buttons.discard');
  }

  onEditDatatableFilterBtnModal(): void {
    this.tempFilters = [...this.filters];
    this.savedFilterName = this.selectedFilterName || '';
    this.saveAsGlobal = this.selectedFilter?.isGlobal || false;
    this.updateSaveButtonState();
    this.openFiltersModal(this.saveFiltersContent, 'buttons.edit_filters', 'buttons.update', 'buttons.discard');
  }

  onUpdateDatatableFilterBtn() {
    this.dataTableState.datatableFilterName = this.savedFilterName;
    this.selectedFilterName = this.savedFilterName;
    this.dataTableState.datatableFilterIsGlobal = this.saveAsGlobal;
    this.filters = [...this.tempFilters];
    this.dataTableState.datatableFilterId = this.selectedFilter?.id;

    this.updateDataTableSettingsEvent.emit(this.dataTableState);

    this.savedFilterName = '';
    this.saveAsGlobal = false;
    this.isEditMode = false;
    this.showHideSaveDatatableFilterBtn(false);
  }

  updateSaveButtonState(isApplyDatatableFilter?: boolean): void {
    if (isApplyDatatableFilter) {
      const isSelectedFilter = !!this.selectedFilter;
      this.isSaveDisabled$.next(!isSelectedFilter);
    } else {
      this.isSaveDisabled$.next(!this.savedFilterName.trim());
    }
  }

  openFiltersModal(content: TemplateRef<any>, title: string, saveText: string, cancelText: string) {
    const modalRef = this.modalService.open(FiltersModalComponent, { size: 'md', centered: true, windowClass: 'filters-modal', });

    modalRef.componentInstance.title = this.translate.instant(title);
    modalRef.componentInstance.modalBody = content;
    if (title === 'buttons.apply_saved_filters') {
      modalRef.componentInstance.showSaveButton = false;
      modalRef.componentInstance.showCancelButton = false;
    }
    modalRef.componentInstance.saveButtonText = this.translate.instant(saveText);
    modalRef.componentInstance.cancelButtonText = this.translate.instant(cancelText);
    modalRef.componentInstance.saveDisabled$ = this.isSaveDisabled$;

    modalRef.result.then(
      (confirmed) => {

        if (title === 'buttons.save_filters' && this.savedFilterName === this.defaultConfigurationTranslation) {
          this.toastr.show(this.translate.instant('messages.empty_configuration_message'), ToastTypesEnum.ERROR);
          return;
        }

        if (confirmed) {
          this.handleModalAction(title);
        } else {
          this.savedFilterName = '';
          this.saveAsGlobal = false;
          this.resetSavedFiltersDataTableState();
        }
      },
      () => {
        this.savedFilterName = '';
        this.saveAsGlobal = false;
        this.resetSavedFiltersDataTableState();
      }
    );
  }

  selectSavedFilter(filter: any, isEdit: boolean = false) {
    this.selectedFilter = filter;
    this.selectedFilterName = filter.name || '';
    this.isEditMode = isEdit;

    if (filter.id === -1) {
      this.setDefalutDataTableConfig();
      this.updateSaveButtonState(false);

      this.configurationService.applyDataTableFilterList(this.dataTableState.gridName, -1)
        .pipe(take(1))
        .subscribe();

    } else {
      this.updateSaveButtonState(true);
      this.onApplyDatatableFilterBtn();
    }

    setTimeout(() => {
      this.modalService.dismissAll();
    });
  }

  deleteSavedFilter(filter: any): void {
    if (!filter?.id || filter.id === -1) return;

    this.configurationService.deleteSavedFilter(filter.id)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.toastr.show(
            this.translate.instant('messages.filter_successfully_deleted'),
            ToastTypesEnum.SUCCESS
          );
          this.getDataTableFilterList();
        },
        error: (err) => {
          this.toastr.show(
            this.translate.instant('messages.failed_to_delete_filter'),
            ToastTypesEnum.ERROR
          );
          console.error(err);
        }
      });
  }

  setDefalutDataTableConfig() {
    this.filters = [];
    this.dataTableState.datatableFilters = [];
    this.orgColumns = this.helperService.deepCopy(this.defaultColumns);
    this.columns = this.defaultColumns;

    this.handleDatatableColumns();

    setTimeout(() => {
      this.dataTableState.pageNumber = 1;
      this.setDatatableStateOnSessionAndEmitChangeEvent(true);
    });
  }

  removeFilterTemp(filter: DataTableColumnFiltersApi) {
    this.tempFilters = this.tempFilters.filter(f => f.columnName !== filter.columnName);
  }

  handleModalAction(title: string) {
    if (title === 'buttons.save_filters') {
      this.onSaveDatatableFilterBtn();
    } else if (title === 'buttons.edit_filters') {
      this.onUpdateDatatableFilterBtn();
    } else if (title === 'buttons.apply_saved_filters') {
      this.onApplyDatatableFilterBtn();
    }
  }

  onApplyDatatableFilterBtn() {

    if (!this.selectedFilter || !this.selectedFilter.id) {
      return;
    }

    this.filters = [];
    this.dataTableState.datatableFilters = [];

    this.configurationService.getDataTableConfigurationId(this.selectedFilter.id)
      .pipe(take(1))
      .subscribe((res: any) => {

        if (res && res.gridColumnSettings && !!JSON.parse(res.gridColumnSettings).length) {
          const gridColumnSettings = JSON.parse(res.gridColumnSettings);

          this.applyColumnsSettings(gridColumnSettings, true)
        }

        if (res && res.gridFilterSettings && !!JSON.parse(res.gridFilterSettings).length) {
          const gridFilterSettings = JSON.parse(res.gridFilterSettings);
          this.filters = gridFilterSettings;

          this.filters = this.removeEmptyFilters();
          this.dataTableState.datatableFilters = this.filters;
          this.closeFilter();
        }

        this.showHideSaveDatatableFilterBtn(false);
        this.dataTableState.pageNumber = 1;
        this.setDatatableStateOnSessionAndEmitChangeEvent(true);
        this.resetSavedFiltersDataTableState();
      });
  }

  getDataTableFilterList() {

    if (!this.dataTableState.gridName) {
      return;
    }

    this.configurationService.getDataTableFilterList(this.dataTableState.gridName, this.savedFiltersDataTableState)
      .pipe(take(1))
      .subscribe((res: ListResponse<any>) => {
        this.savedFilters = [...res.items];
        this.savedFiltersTotalCount = res.totalCount;
      });
  }

  savedFiltersChangeEvent(data: any, type: string) {
    switch (type) {
      case this.dataTableEventsChangePage:
        this.savedFiltersDataTableState.pageNumber = data.page;
        break;
      case this.dataTableEventsChangeItemPerPage:
        this.savedFiltersDataTableState.pageNumber = 1;
        this.savedFiltersDataTableState.showItemsPerPage = data.id;
        break;
    }

    this.getDataTableFilterList();
  }

  resetSavedFiltersDataTableState() {
    this.savedFiltersDataTableState.pageNumber = 1;
    this.savedFiltersDataTableState.showItemsPerPage = DataTableItemsPerPageEnum.ITEMS_PER_PAGE_100;
  }

  returnTrue(): boolean {
    return true;
  }

  onSearch($event: any, columnProperty: string, rowIndex: number, row: any, items: any) {
    this.enableAddSelectBtn = false;
    if ((($event.term.length === 0) || ($event.term.length > 2)) && this.externalSearch) {
      const data: any = {
        search: $event.term,
        columnProperty: columnProperty,
        rowIndex: rowIndex,
        row: row,
        items: items
      }
      this.searchInput$.next(data);
    }
  }

  onClear(columnProperty: string, rowIndex: number, row: any) {
    const data: any = {
      search: '',
      columnProperty: columnProperty,
      rowIndex: rowIndex,
      row: row,
    }
    this.onClearEvent.emit(data);
  }

  getTableClasses() {
    return {
      'ngx-datatable-sticky-header': this.stickyHeader,
      [this.tableSizeClass]: this.tableSizeClass
    };
  }

  setDefaultFilter(row: any) {
    this.configurationService.setDefaultFilter(row.id).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      if (row.isGlobal && this.isAdmin) {
        row.isDefault = true;
        this.savedFilters.map(f => {
          f.isDefault = row.id === f.id;
        });
        const message: string = this.translate.instant('messages.filter_default_successfully_updated', { filter: row.name });
        this.toastr.show(
          this.translate.instant(message),
          ToastTypesEnum.SUCCESS
        );
      }
    })
  }

  setDatatableStateOnSessionAndEmitChangeEvent(emitToCallApi: boolean) {
    this.gridSettingsChanged = true;
    this.helperService.storeGridFilterObjectToSessionStorage(this.dataTableState.gridName, this.dataTableState);
    if (emitToCallApi) {
      this.dataTableStateEvent.emit(this.dataTableState);
    }
    this.hardResetTable();
  }

  downloadExportDataFile() {
    this.dynamicTableService.getExportDataFile(this.exportDataApiPath, this.dataTableState, this.exportQueryGlobalSearch).pipe(takeUntil(this.unsubscribe$)).subscribe((blob: any) => {
      const file = { fileName: this.dynamicTableService.generateExportFileName(this.dataTableState) };
      this.helperService.saveFile(file, blob);
    });
  }

  hardResetTable() {
    this.isTableVisible = false;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.isTableVisible = true;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
